export default {
  page_title: 'Visitor Widget Settings',
  widget: {
    enabled_label: 'Enable',
    embed_link_label: 'Embed link (iframe)',
    copy: 'Copy',
    copied: 'Copied',
    no_key_yet: 'No key issued yet',
    public_key_label: 'Public key',
    generate_key: 'Generate key',
    rotate_key: 'Rotate key',
    rotate_confirm_title: 'Rotate the public key?',
    rotate_confirm_message:
      "Rotating issues a new key immediately and invalidates the old one. Any iframe already embedded on your website using the current key will stop working until you update it with the new link.",
    create_title: 'No visitor widget yet',
    create_description:
      'Create a visitor widget for this property to get an embeddable registration form and a public key.',
    create_action: 'Create widget',
  },
  availability: {
    weekday: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
    },
    closed: 'Closed',
    open_today: 'Open this day',
    add_window: 'Add a window',
    remove_window: 'Remove window',
    window_from: 'Start time',
    window_to: 'End time',
    validation_incomplete: 'Every window needs both a start and an end time.',
    validation_order: "Each window's start time must be before its end time.",
    validation_overlap: 'Windows on the same day cannot overlap.',
  },
  settings: {
    slot_minutes_label: 'Slot length (minutes)',
    lead_time_minutes_label: 'Lead time (minutes)',
    max_per_slot_label: 'Visitors per slot',
    booking_window_days_label: 'Booking window (days)',
  },
  messages: {
    widget_created: 'Visitor widget created',
    create_error: 'Could not create the visitor widget',
    settings_saved: 'Settings saved',
    save_error: 'Could not save the settings',
    key_rotated: 'Public key rotated',
    rotate_error: 'Could not rotate the public key',
    enabled_on: 'Widget enabled',
    enabled_off: 'Widget disabled',
    toggle_error: 'Could not update the widget',
  },
  iframe: {
    kicker: 'Visitor registration',
    tagline: 'Pre-register your visit so staff can have your badge ready.',
    not_found_title: 'Widget unavailable',
    not_found_message:
      'This visitor registration page is no longer available. Please contact the property directly.',
    pick_date_title: 'Pick a date and time',
    date_label: 'Date',
    no_slots: 'No slots available on this date.',
    availability_error: 'Could not load available slots. Please try again.',
    back: 'Back',
    details_title: 'Your details',
    first_name: 'First name',
    last_name: 'Last name',
    phone: 'Phone number',
    send_otp: 'Send verification code',
    invalid_phone: 'Please enter a valid Thai mobile number (e.g. 0812345678).',
    send_error: 'Could not send the code. Please try again in a moment.',
    otp_title: 'Enter the verification code',
    otp_hint: 'We sent a 6-digit code to your phone.',
    otp_code: 'Verification code',
    verify: 'Verify',
    invalid_otp: 'That code is not valid. Please try again.',
    consent_title: 'Confirm your visit',
    consent_checkbox:
      'I consent to the property collecting and using my name and phone number for this visit.',
    confirm_booking: 'Confirm booking',
    slot_filled: 'That slot was just booked by someone else. Please pick another time.',
    book_error: 'Could not confirm the booking. Please try again.',
    context_lost: 'Please start over and pick a slot.',
    confirmed_title: 'Booking confirmed',
    confirmed_message: 'See you at {{property}} soon.',
    book_another: 'Book another visit',
  },
  dashboard_strip: {
    title: 'Today',
    view_all: 'View all arrivals',
    staff_on_shift: 'Staff on shift: {{count}}',
    visitors_today: 'Visitors today: {{count}}',
    not_yet_arrived: 'Not yet arrived: {{count}}',
  },
  arrivals: {
    title: 'Visitor arrivals',
    subtitle: 'Today’s expected and walk-in visitors',
    empty: 'No arrivals scheduled for today.',
    load_error: 'Could not load today’s arrivals. Please try again.',
    status: {
      booked: 'Booked',
      arrived: 'Arrived',
      departed: 'Departed',
      cancelled: 'Cancelled',
      no_show: 'No-show',
    },
    actions: {
      check_in: 'Arrived',
      check_out: 'Departed',
      cancel: 'Cancel',
    },
  },
}
